import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Qty } from "../shared";

export const inputCls = "h-11 w-full px-3 bg-[#090D16] border border-[#334155] rounded-md focus:outline-none focus:border-[#F59E0B] text-sm";
export const L = ({ label, hint, children }) => (
  <label className="flex flex-col gap-1"><span className="font-mono text-[10px] tracking-[0.2em] text-[#6B7280]">{label}</span>{children}{hint && <span className="text-[11px] text-[#6B7280]">{hint}</span>}</label>
);
export const NUM = ["par_level", "unit_cost", "order_unit_qty", "lead_time_days", "unit_yield", "batch_size", "setup_minutes", "max_daily_qty", "selling_price", "assembly_minutes",
  "override_adcr_window_days", "override_dos_days", "override_drift_pct"];
export const money = (v) => `$${(v || 0).toFixed(2)}`;
const extKey = (it) => ((it.external_sku || "").trim() ? `${it.supplier_id || ""}|${it.external_sku.trim().toLowerCase()}` : null);
// Other items from the same supplier already using this external SKU
export const extSkuClashes = (items, it) => { const k = extKey(it); return k ? items.filter((o) => o.id !== it.id && extKey(o) === k) : []; };
export const dupExtSkuIds = (items) => {
  const groups = {};
  items.forEach((i) => { const k = extKey(i); if (k) (groups[k] = groups[k] || []).push(i.id); });
  return new Set(Object.values(groups).filter((g) => g.length > 1).flat());
};
export const confirmExtSku = (items, it) => {
  const c = extSkuClashes(items, it);
  return !c.length || window.confirm(`External SKU "${it.external_sku.trim()}" is already used by ${c.map((o) => `${o.name} (${o.sku})`).join(", ")} from the same supplier.\n\nPOs will show the same part # for different items. Save anyway?`);
};
export const baseCost = (it) => (it.base_unit_cost ?? Math.round(((it.unit_cost || 0) - (it.landed_adjustment || 0)) * 10000) / 10000);

export function usePolicy(it) {
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/items/${it.id}/policy`).then((r) => setP(r.data)).catch(() => setP(null)); },
    [it.id, it.par_level, it.policy_override, it.override_adcr_window_days, it.override_dos_days, it.override_drift_pct, it.lead_time_days, it.override_cost_engine, it.manual_cost_override]);
  return p;
}

export function bomUnitCost(id, itemsById, bomsByProduct, seen = new Set()) {
  const it = itemsById[id];
  const bom = bomsByProduct[id];
  if (!it || seen.has(id)) return 0;
  if (!bom) return it.unit_cost || 0;
  seen.add(id);
  return bom.components.reduce((a, c) => a + c.qty * bomUnitCost(c.item_id, itemsById, bomsByProduct, seen), 0);
}

export const Stat = ({ label, value, unit, cls = "", testId }) => (
  <div className="p-4 rounded-md bg-[#090D16] border border-[#1E293B]" data-testid={testId}>
    <div className="font-mono text-[10px] tracking-[0.2em] text-[#6B7280]">{label}</div>
    <Qty v={value} unit={unit} className={`text-2xl font-bold ${cls}`} />
  </div>
);
